<template>
  <div>
    <h2 class="text-center">Materias Docente</h2>
    <v-dialog v-model="cargando" hide-overlay persistent width="300">
      <v-card color="primary" dark class="loading">
        <v-card-text>
          Espere un momento
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template v-if="materias.length > 0 ">
      <v-data-table
        :headers="headers"
        :items="materias"
        ref="lista_promedios"
        class="elevation-1"
        hide-default-footer
      >
        <!--<template v-slot:items="props">
          <td class="text-xs-left">{{ mayus(props.item.nombre) }}</td>
          <td class="text-xs-left">{{ mayus(props.item.agrupamiento) }}</td>
          <td class="text-xs-left">-</td>
        </template>-->
      </v-data-table>
    </template>
    <template v-else>
      <h3>El Docente no posee materias asigndas !</h3>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
export default {
  data: () => ({
    cargando: false,
    headers: [
      {
        text: "Materia",
        align: "left",
        sortable: false,
        value: "nombre"
      },
      {
        text: "Curso",
        align: "left",
        sortable: false,
        value: "agrupamiento"
      },
      {
        text: "Horas",
        align: "left",
        sortable: false,
        value: "",
        class: "headerGrid"
      }
    ],
    materias: []
  }),
  props: ["idProfesor"],
  computed: {},
  mounted: function() {
    this.obtenerMateriasDocente();
  },
  watch: {
    idProfesor: function() {
      this.obtenerMateriasDocente();
    }
  },
  methods: {
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    obtenerMateriasDocente() {
      this.cargando = true;
      let params = "idProfesor=" + this.idProfesor;

      let resultado = API.enviar("get", "obtenerMateriasDeProfesor", params);

      resultado
        .then(result => {
          this.materias = result.data;
        })
        .catch(error => {
          console.log(" | methods | guardarUsuario |  catch: -> ", error);
        })
        .finally(() => {
          this.cargando = false;
        });
    }
  }
};
</script>

<style scoped>
h3 {
  padding: 20px;
}
</style>